import classes from "./ErrorCard.scss";
import BpMatchForm from "../Presentational/bpMatchForm";
import SceButton from "../../Common/CommonComponents/sceButton";
import { getLocalizedStrings } from "../centralizedLocalizedString";
const ErrorCard = (props) => {
  let strings = getLocalizedStrings("ErrorCard");
  let warningImg =
    drupalSettings.path.baseUrl +
    "themes/custom/sce_responsive/images/Icon _ Warning.svg";
  let cntr = props.bpErrorCntr;
  return (
    <div>
      {props.bpMatch && cntr < 2 ? null : props.bpMatch ? (
        <div className={classes.errorBanner}>
          <div className={classes.errorMessageContainerOne}>
            <div className={classes.errorMessage}>
              <p>
                <img className={classes.errorImage} src={warningImg} alt="Warning Image" />
              </p>
              <div className={classes.errorSingleStatement}>
                <div className={classes.errorSubtext}>
                 {(cntr < 3)? props.bpMessageOne : props.bpMessageTwo}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className={classes.errorBanner}>
          <div className={classes.errorMessageContainer}>
            <div className={classes.errorMessage}>
              <p>
                <img className={classes.errorImage} src={warningImg} alt="Warning Image" />
              </p>
              <div className={classes.errorSingleStatement}>
                <div className={classes.errorMaintext}>{props.mainMessage}</div>
                <div className={classes.errorSubtext}>{props.subMessage}</div>
              </div>
            </div>
            <div className={classes.SceButton}>
              <SceButton
                iconType="return"
                buttonType="sceFullPrimary"
                value="Refresh Page"
                onClick={() => window.location.reload(false)}
              />
            </div>
          </div>
        </div>
      )}
      {/* add is webuser condition here */}
      {props.bpMatch ? (
        <div className={classes.bpMatchFormContainer}>
          {props.bpErrorMsgSwitch
            ? strings.BpMatchTextOne
            : strings.BpMatchTextTwo}
          <div className={classes.bpMatchForm}>
            <BpMatchForm
              firstName={props.firstName}
              lastName={props.lastName}
              emailId={props.emailId}
              disp={props.disp}
              retrieveInputData={props.retrieveInputData}
              profileData={props.profileData}
            />
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default ErrorCard;